import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { APP_CONFIG, AppConfig } from "app/app.config";
import { catchError, from, switchMap, throwError } from "rxjs";

import { AuthService } from "./auth/auth.service";

export const httpMaintenanceInterceptor: HttpInterceptorFn = (
  request,
  next
) => {
  const auth = inject(AuthService);
  const config = inject<AppConfig>(APP_CONFIG);
  const isBackendRequest = request.url.startsWith(config.ApiOrigin);

  if (!isBackendRequest) {
    return next(request);
  }

  const withToken = () => {
    const accessToken = auth.getAccessToken();
    return accessToken
      ? request.clone({
          setHeaders: { Authorization: `Bearer ${accessToken}` }
        })
      : request;
  };

  return next(withToken()).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 503) {
        auth.logout();
        return throwError(() => error);
      }

      if (
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        auth.hasRefreshToken()
      ) {
        return from(auth.refreshAccessToken()).pipe(
          switchMap(() => next(withToken())),
          catchError((refreshError) => {
            auth.logout();
            return throwError(() => refreshError);
          })
        );
      }

      return throwError(() => error);
    })
  );
};
